import { useAppDispatch, useAppSelector } from "app/hooks"
import { createRecentIngredient } from "../foodSlice"
import { useFailed } from "features/notification/hooks"
import { CreateRecentIngredientPayload } from "model/food/types/recentIngredient.types"

export const useCreateRecentIngredient = () => {
  const createRecentIngredientLoading = useAppSelector(
    (state) => state.food.createRecentIngredientLoading,
  )
  const createRecentIngredientFailed = useAppSelector(
    (state) => state.food.createRecentIngredientFailed,
  )

  const dispatch = useAppDispatch()

  const handleCreateRecentIngredient = (
    payload: CreateRecentIngredientPayload,
  ) => {
    dispatch(createRecentIngredient(payload))
  }

  useFailed(createRecentIngredientFailed)

  return {
    createRecentIngredientLoading,
    handleCreateRecentIngredient,
  }
}
